import { mapGetters } from 'vuex'
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'

export const listMixin = {
  data() {
    return {
      apiUrl: undefined,
      totalItems: 0,
      pagination: {
        sortDesc: [false],
        page: 1
      }
    }
  },
  computed: {
    ...mapGetters([
      'checkAccess'
    ]),
    listHeaders() {
      let result = []
      for (const selectedColumn of this.selectedColumns) {
        let findCol = this.columns.find(a => selectedColumn === a.value)
        if (findCol) {
          result.push(findCol)
        }
      }
      result.push(TableConst.tableActionHeader)
      return result
    },
    // OS-104: Added 17/April for claimRIListHeaders columns in single page
    claimRIListHeaders() {
      let claimRIListResult = []
      for (const selectedColumn of this.selectedClaimRIColumns) {
        let findCol = this.claimRIColumns.find(a => selectedColumn === a.value)
        if (findCol) {
          claimRIListResult.push(findCol)
        }
      }
      return claimRIListResult
    }
  },
  mixins: [
    TableConst.default,
    MessageMixin
  ]
}
